import { defaultDateFormatForBeServices } from '../../../../constants/dates';
import { StaticFilters, StorageCampaign } from '../../../../pages/baymax/types/reports';
import { modifiedDate } from '../../../../utils/time';
import { DateRange, MetricsInput } from '../../types';

export const getMetricOptions = (
  templateId: string,
  { startDate, endDate, dateRange }: StaticFilters
): MetricsInput => ({
  templateId,
  dateRange: dateRange as DateRange,
  ...(dateRange === DateRange.Custom &&
    startDate &&
    endDate && {
      startDate: modifiedDate(new Date(startDate), defaultDateFormatForBeServices),
      endDate: modifiedDate(new Date(endDate), defaultDateFormatForBeServices),
    }),
});

export const getCampaignIds = (campaigns?: StorageCampaign[]): string[] => {
  return campaigns?.map((campaign) => campaign.id) || [];
};

export const getDateForStatistics = (range?: string, date?: string): string | undefined =>
  range === DateRange.Custom && date ? modifiedDate(new Date(date), defaultDateFormatForBeServices) : undefined;
